import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"display":"contents"},
  ref: "root"
}
const _hoisted_2 = { class: "ProductCategory-aside" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "category-nav" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "banner" }, null, -1)
const _hoisted_5 = { class: "ProductCategory-content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "category-header" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "sub-categories" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "top-seller" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { "data-slot": "recommended-list" }, null, -1)
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterHolder = _resolveComponent("FilterHolder")!
  const _component_FilterSelection = _resolveComponent("FilterSelection")!
  const _component_ButtonOpenFilter = _resolveComponent("ButtonOpenFilter")!
  const _component_CategorySort = _resolveComponent("CategorySort")!
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_Pager = _resolveComponent("Pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_FilterHolder, { "is-loading": _ctx.isLoadingFilters }, null, 8, ["is-loading"]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      (_ctx.isLoadingProducts)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.loadingProductsLabel), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        style: {"display":"contents"},
        class: _normalizeClass({'u-hidden': _ctx.isLoadingProducts})
      }, [
        _createVNode(_component_FilterSelection),
        _createVNode(_component_ButtonOpenFilter, {
          text: _ctx.openFilterLabel,
          onClick: _ctx.openFilterModal
        }, null, 8, ["text", "onClick"]),
        _createVNode(_component_CategorySort),
        _createVNode(_component_ProductList),
        _createVNode(_component_Pager)
      ], 2)
    ])
  ], 512))
}